import { aboutInfo } from '@/mocks/home';

export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 w-full max-w-sm lg:max-w-none">
            <div className="relative w-full aspect-square max-w-xs mx-auto rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20inviting%20comic%20book%20library%20interior%20scene%20with%20bookshelves%20filled%20with%20colorful%20manga%20volumes%20cozy%20reading%20nook%20with%20warm%20orange%20amber%20lighting%20comfortable%20atmosphere%20digital%20illustration%20style%20modern%20bookshop%20aesthetic%20with%20comic%20culture%20elements%20editorial%20composition&width=600&height=600&seq=about-brand&orientation=squarish"
                alt="51漫画品牌形象 - 温暖的漫画图书馆"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">关于我们</h2>
            <h3 className="text-lg md:text-xl font-semibold text-foreground-900 mb-4">{aboutInfo.title}</h3>
            {aboutInfo.paragraphs.map((p, idx) => (
              <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">{p}</p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}